module.exports = __webpack_public_path__ + "static/img/gqbjxj.b73b24a3.svg";